import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Arrow Up Icon',
};

export const ArrowUpIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.18576 5.53721L4.85737 9.86566C4.53937 10.1837 4.0238 10.1837 3.70579 9.86567C3.38779 9.54767 3.38779 9.03209 3.70579 8.71409L9.42418 2.99563C9.57689 2.84292 9.78401 2.75713 9.99997 2.75713C10.2159 2.75713 10.423 2.84292 10.5758 2.99563L16.2942 8.71409C16.6122 9.03209 16.6122 9.54767 16.2942 9.86566C15.9762 10.1837 15.4606 10.1837 15.1426 9.86566L10.8143 5.53736L10.8143 16.4286C10.8143 16.8783 10.4498 17.2429 10.0001 17.2429C9.55033 17.2429 9.18576 16.8783 9.18576 16.4286L9.18576 5.53721Z"
            />
        </SvgIcon>
    );
};
